import { render } from "./OurTestimonial.vue?vue&type=template&id=4a7908aa&ts=true"
import script from "./OurTestimonial.vue?vue&type=script&lang=ts"
export * from "./OurTestimonial.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__